<template>
  <div class="flex-row-between-center gap-1 w-100">
    <template v-for="(item, index) in items">
      <StepperItem
        :key="`${item}-bullet`"
        :title="$t(item)"
        :active="currentStep === index"
        :done="index < currentStep"
        :first="index === 0"
        :last="index + 1 === items.length"
      />
      <div
        :key="`${item}-divider`"
        class="steps-divider"
        :class="{ 'active-divider': currentStep >= index }"
        v-if="index + 1 < items.length"
      >
        <svg viewBox="0 0 220 100" preserveAspectRatio="none">
          <path d="M5 50 l215 0" />
        </svg>
      </div>
    </template>
  </div>
</template>

<script>
import StepperItem from "./StepperItem.vue";

export default {
  name: "BalanceStepper",

  props: {
    items: { type: Array },
    currentStep: { type: Number },
  },

  components: {
    StepperItem,
  },
};
</script>

<style lang="scss" scoped>
.steps-divider {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5px;
  & svg {
    width: 95%;
    height: 5px;
    & path {
      fill: none;
      stroke: var(--v-midGrey-base);
      stroke-width: 40;
      stroke-dasharray: 5;
    }
  }
}
.active-divider {
  & svg {
    & path {
      stroke: var(--v-text-base) !important;
    }
  }
}
</style>
